var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingCarouselImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1076,
    height: 411,
    viewBox: "0 0 1076 411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_home_niyama",
    transform: "translate(-145 -583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_how_niyama_works",
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 1076,
    height: 411,
    transform: "translate(145 599)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("text", {
    id: "How_Niyama_Work",
    "data-name": "How Niyama Work",
    transform: "translate(683 645)",
    fill: "#029701",
    fontSize: 20,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -84,
    y: 0
  }, "How Niyama Work")), /*#__PURE__*/React.createElement("text", {
    id: "_-_What_we_do_-",
    "data-name": "- What we do -",
    transform: "translate(683 617)",
    fill: "#424242",
    fontSize: 18,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -59,
    y: 0
  }, "- What we do -"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-15 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(654 685)",
    fill: "#ffcdd2",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(659 690)",
    fill: "#ffebee"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Sign_In",
    "data-name": "Sign In",
    transform: "translate(698 797)",
    fill: "#424242",
    fontSize: 18,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26,
    y: 0
  }, "Sign In")), /*#__PURE__*/React.createElement("text", {
    id: "Register_and_login_to_know_your_results",
    "data-name": "Register and login to know  your results",
    transform: "translate(698 824)",
    fill: "#9e9e9e",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -93,
    y: 0
  }, "Register and login to know"), /*#__PURE__*/React.createElement("tspan", {
    x: -42,
    y: 19,
    xmlSpace: "preserve"
  }, " your results"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-369 135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(0 29)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(654 685)",
    fill: "#ffd1d6",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(659 690)",
    fill: "#ffebee"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Answer_The_Question",
    "data-name": "Answer The Question",
    transform: "translate(694 826)",
    fill: "#424242",
    fontSize: 18,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -85,
    y: 0
  }, "Answer The Question")), /*#__PURE__*/React.createElement("text", {
    id: "Share_your_problems_through_the_questionnaire",
    "data-name": "Share your problems through the questionnaire",
    transform: "translate(694 853)",
    fill: "#9e9e9e",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -115,
    y: 0
  }, "Share your problems through the"), /*#__PURE__*/React.createElement("tspan", {
    x: -47,
    y: 19
  }, "questionnaire"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(369 164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(-10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(654 685)",
    fill: "#ffd1d6",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-3",
    "data-name": "Ellipse 1",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(659 690)",
    fill: "#ffebee"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Take_Treatment",
    "data-name": "Take Treatment",
    transform: "translate(684 797)",
    fill: "#424242",
    fontSize: 18,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60,
    y: 0
  }, "Take Treatment")), /*#__PURE__*/React.createElement("text", {
    id: "Choose_the_right_treatment_according_to_your_severity",
    "data-name": "Choose the right treatment according  to your severity",
    transform: "translate(684 824)",
    fill: "#9e9e9e",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -133,
    y: 0
  }, "Choose the right treatment according "), /*#__PURE__*/React.createElement("tspan", {
    x: -54,
    y: 19
  }, "to your severity"))), /*#__PURE__*/React.createElement("g", {
    id: "home_long_arrow1",
    transform: "translate(0 9.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M365,840.594s27.538-47.826,73.788-67.243S550,762.928,550,762.928",
    transform: "translate(10 -15.735)",
    fill: "none",
    stroke: "#7e57c2",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M560.918,745.113,545.36,768.541",
    transform: "translate(-0.918 1.998)",
    fill: "none",
    stroke: "#7e57c2",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M560.918,768.541,545.36,745.113",
    transform: "translate(-0.918 -21.255)",
    fill: "none",
    stroke: "#7e57c2",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "home_long_arrow2",
    transform: "translate(6 -13.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M555.854,848.932s-33.07-56.463-79.415-75.7S365,762.909,365,762.909",
    transform: "translate(435 -15.735)",
    fill: "none",
    stroke: "#7e57c2",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M15.558,0,0,23.428",
    transform: "matrix(0.616, 0.788, -0.788, 0.616, 981.461, 822.113)",
    fill: "none",
    stroke: "#7e57c2",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M15.558,23.428,0,0",
    transform: "matrix(0.616, 0.788, -0.788, 0.616, 1000.422, 807.571)",
    fill: "none",
    stroke: "#7e57c2",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(633 690)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758",
    transform: "translate(37.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M130.279,0a9.279,9.279,0,1,0,9.279,9.279A9.29,9.29,0,0,0,130.279,0Z",
    transform: "translate(-121)",
    fill: "#7e57c2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760",
    transform: "translate(31 20.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M57.865,304a13.122,13.122,0,0,0-9.432-4h-4.1a13.122,13.122,0,0,0-9.432,4,13.561,13.561,0,0,0-3.9,9.541,1.028,1.028,0,0,0,1.025,1.031H60.738a1.028,1.028,0,0,0,1.025-1.031A13.56,13.56,0,0,0,57.865,304Z",
    transform: "translate(-31 -300)",
    fill: "#7e57c2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_036---Hydrotherapy",
    "data-name": "036---Hydrotherapy",
    transform: "translate(1037 855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 5,
    height: 14,
    rx: 1,
    transform: "translate(0 21)",
    fill: "#7e57c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M36.808,38.844,25.3,42.683c-.643.213-.445.159-6.513.159a5.316,5.316,0,0,0-3.216,1.14.622.622,0,1,1-.69-1.035l.456-.3A6.217,6.217,0,0,1,18.781,41.6H22.56c.982-1.317-.435-3.11-2.1-3.11H17.211a6.322,6.322,0,0,1-4-1.431A4.931,4.931,0,0,0,10.072,36h-.45A.622.622,0,0,0,9,36.622v11.2a.622.622,0,0,0,.622.622H24.115a3.732,3.732,0,0,0,1.941-.544l11.659-7.1a1.081,1.081,0,0,0,.3-1.574A1.062,1.062,0,0,0,36.808,38.844Z",
    transform: "translate(-3.402 -13.607)",
    fill: "#7e57c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M30.33,22.393c5.15,0,9.33-3.875,9.33-8.652S30.33,0,30.33,0,21,8.963,21,13.741,25.18,22.393,30.33,22.393Zm-4.976-9.33a.622.622,0,0,1,.622-.622h2.488a.622.622,0,0,0,.622-.622V9.33a.622.622,0,0,1,.622-.622h1.244a.622.622,0,0,1,.622.622v2.488a.622.622,0,0,0,.622.622h2.488a.622.622,0,0,1,.622.622v1.244a.622.622,0,0,1-.622.622H32.2a.622.622,0,0,0-.622.622v2.488a.622.622,0,0,1-.622.622H29.708a.622.622,0,0,1-.622-.622V15.551a.622.622,0,0,0-.622-.622H25.976a.622.622,0,0,1-.622-.622Z",
    transform: "translate(-7.937)",
    fill: "#7e57c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "conversation",
    transform: "translate(307 856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M22.672,15.55,22.647,3.072A3.083,3.083,0,0,0,19.568,0H3.078A3.082,3.082,0,0,0,0,3.078v12.45a3.082,3.082,0,0,0,3.078,3.078H5.2v2.052a1.027,1.027,0,0,0,1.642.821l3.829-2.872,8.915.027A3.076,3.076,0,0,0,22.672,15.55ZM11.287,14.433a1.026,1.026,0,1,1,1.026-1.026A1.026,1.026,0,0,1,11.287,14.433Zm1.095-4.28v.108a1.026,1.026,0,1,1-2.052,0V9.62A1.371,1.371,0,0,1,11.5,8.267a1.029,1.029,0,0,0,.881-1.016,1.069,1.069,0,0,0-1.767-.786A1.026,1.026,0,0,1,9.509,4.736a3.226,3.226,0,0,1,3.323-.187,3.079,3.079,0,0,1-.451,5.6Z",
    transform: "translate(0 0)",
    fill: "#7e57c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M200.564,210.995h-7.223l0,1.112a5.129,5.129,0,0,1-4.134,5.045h9.235a1.026,1.026,0,0,1,0,2.052H186.13a1.026,1.026,0,0,1-.416-1.963L181,217.226v9.228a3.082,3.082,0,0,0,3.078,3.078h6.94l3.888,1.944a1.027,1.027,0,0,0,1.485-.918v-1.026h4.173a3.082,3.082,0,0,0,3.078-3.078V214.073A3.082,3.082,0,0,0,200.564,210.995Zm-2.121,12.313H186.13a1.026,1.026,0,0,1,0-2.052h12.313a1.026,1.026,0,0,1,0,2.052Z",
    transform: "translate(-168.643 -196.586)",
    fill: "#7e57c2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingCarouselImage);
export default __webpack_public_path__ + "static/media/landing_carousel_image.c88f4258.svg";
export { ForwardRef as ReactComponent };